export const formatEvidenceSessionOrigin = (origin: string) => {
  if (origin === 'inspection') {
    return 'Inspection';
  }
  if (origin === 'seller-self-serve') {
    return 'Seller Self Serve';
  }
  if (origin === 'site-material') {
    return 'Site Material';
  }
  if (origin === 'site') {
    return 'Site';
  }
  if (origin === 'sample') {
    return 'Sample';
  }
  if (origin === 'seller-sample') {
    return 'Seller Sample';
  }
};
